import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
} from '@mui/material';
import { PeriodType, getPeriodParams } from '../../utils/dateFilters';

interface PeriodFilterProps {
  period: PeriodType;
  onPeriodChange: (period: PeriodType) => void;
  dateFrom: string;
  dateTo: string;
  onDateFromChange: (date: string) => void;
  onDateToChange: (date: string) => void;
  onApply?: () => void;
  showCustomDates?: boolean;
  size?: 'small' | 'medium';
}

export const PeriodFilter: React.FC<PeriodFilterProps> = ({
  period,
  onPeriodChange,
  dateFrom,
  dateTo,
  onDateFromChange,
  onDateToChange,
  onApply,
  showCustomDates = true,
  size = 'small'
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <FormControl size={size} sx={{ minWidth: 140 }}>
        <InputLabel>Período</InputLabel>
        <Select
          label="Período"
          value={period}
          onChange={(e) => onPeriodChange(e.target.value as PeriodType)}
        >
          <MenuItem value="general">Geral</MenuItem>
          <MenuItem value="today">Hoje</MenuItem>
          <MenuItem value="yesterday">Ontem</MenuItem>
          <MenuItem value="7d">Últimos 7 dias</MenuItem>
          <MenuItem value="30d">Últimos 30 dias</MenuItem>
          <MenuItem value="90d">Últimos 90 dias</MenuItem>
          {showCustomDates && <MenuItem value="custom">Personalizado</MenuItem>}
        </Select>
      </FormControl>
      
      {period === 'custom' && showCustomDates && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <TextField
            size={size}
            type="date"
            label="De"
            InputLabelProps={{ shrink: true }}
            value={dateFrom}
            onChange={(e) => onDateFromChange(e.target.value)}
          />
          <TextField
            size={size}
            type="date"
            label="Até"
            InputLabelProps={{ shrink: true }}
            value={dateTo}
            onChange={(e) => onDateToChange(e.target.value)}
          />
          {onApply && (
            <Button 
              variant="contained" 
              size={size} 
              onClick={onApply}
            >
              Aplicar
            </Button>
          )}
        </Box>
      )}
    </Box>
  );
}; 